import { useLayoutEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { USDT_CUR, usdtCurrency } from 'utils/account/account-params';
import { currencyFormat, formatPlacement } from 'utils/generic/currency-format';
import { getPartnerConfigs } from 'store/selectors/socket';
import { getIsLoggedIn, getUser } from 'store/selectors/user-data';

export type TUseCurrencyReturnType = {
  currency: string;
  currencyId: string;
  placement: string;
  formatAmount: (
    amount: string | number,
    checkCurrencyContent?: boolean
  ) => string;
};

export const useCurrency = (): TUseCurrencyReturnType => {
  const [currency, setCurrency] = useState('');
  const { currency: userCurrency } = useSelector(getUser);
  const isLoggedIn = useSelector(getIsLoggedIn);

  const partnerConfig = useSelector(getPartnerConfigs);

  useLayoutEffect(() => {
    if (isLoggedIn && userCurrency) {
      setCurrency(userCurrency);
    } else {
      if (partnerConfig?.currency) {
        setCurrency(partnerConfig.currency);
      }
    }
  }, [partnerConfig, isLoggedIn, userCurrency]);

  return useMemo(() => {
    const currencyData = currencyFormat(currency);
    const currencyDataName =
      currencyData.currency === usdtCurrency ? USDT_CUR : currencyData.currency;

    return {
      currency: currencyDataName,
      currencyId: currency,
      placement: currencyData.placement,
      formatAmount: formatPlacement(currencyDataName, currencyData.placement)
    };
  }, [currency]);
};
